function getVoteViewerRole(voteState, viewerColor) {
    if (voteState.creator == viewerColor) return 'initiator';
    if (voteState.participatingPlayers.includes(viewerColor)) return 'voter';
    return 'observer';
}
function getViewerVoteResponse(voteState, viewerColor) {
    if (voteState.acceptedVotes.includes(viewerColor)) return 'accepted';
    if (voteState.declinedVotes.includes(viewerColor)) return 'declined';
    return 'pending';
}
export function getVoteViewState(voteState, viewerColor) {
    const role = getVoteViewerRole(voteState, viewerColor);
    return {
        role: role,
        viewerVoteResponse: getViewerVoteResponse(voteState, viewerColor),
        title: role == 'initiator' ? voteState.initiatorTitle : voteState.voterTitle,
        showActions: role == 'voter',
        showWaitingMessage: role == 'initiator'
    };
}
